export const LIVING_SURFACE_MAX = 5000;
export const LIVING_SURFACE_MIN = 15;
export const BUILT_SURFACE_MAX = 5000;
export const BUILT_SURFACE_MIN = 15;
export const USABLE_SURFACE_MAX = 5000;
export const USABLE_SURFACE_MIN = 0;
export const LAND_SURFACE_MAX = 500_000;
export const LAND_SURFACE_MIN = 0;
export const BALCONY_SURFACE_MAX = 1000;
export const BALCONY_SURFACE_MIN = 0;
export const GARDEN_SURFACE_MAX = 500_000;
export const GARDEN_SURFACE_MIN = 0;
export const TERRACE_SURFACE_MAX = 1000;
export const TERRACE_SURFACE_MIN = 0;
export const WEIGHTED_FLOOR_SURFACE_MAX = 50000;
export const WEIGHTED_FLOOR_SURFACE_MIN = 0;
export const BASEMENT_SURFACE_MAX = 1000;
export const BASEMENT_SURFACE_MIN = 0;
export const GROSS_FLOOR_SURFACE_MAX = 50000;
export const GROSS_FLOOR_SURFACE_MIN = 0;
export const RESIDENTIAL_AND_COMMERCIAL_SURFACES_MIN = 1;
export const ENERGY_CONSUMPTION_MIN = 1;
export const ENERGY_CONSUMPTION_MAX = 10_000;
export const ESTIMATED_COST_MIN = 1;
export const ESTIMATED_COST_MAX = 1_000_000;
